import axios from "axios";
import { Storage } from "@utils";
import {
  NEWS,
  LIKE,
  MENUS,
  QUERY,
  BANNER,
  API_URL,
  SETTING,
  HEADERS,
  COMMENT,
  USER_OTP,
  LIKE_CLUB,
  FACILITES,
  NEWSLETTER,
  CLUB_SEARCH,
  CLUB_POLICY,
  STATIC_PAGE,
  ALL_STATIC_PAGE,
  UPDATE_USER,
  CLUB_DETAIL,
  SEARCH_CLUBS,
  COUNTRY_LIST,
  EXPOLRE_GAME,
  BOOK_TEETIME,
  PRIVACY_DATA,
  CLUB_TEE_TIME,
  REGISTER_USER,
  LATEST_REVIEW,
  REVIEW_RATING,
  PROFILE_PHOTO,
  CANCEL_BOOKING,
  CREATE_PAYMENT,
  CONFIRM_PAYMENT_ERROR,
  GET_PAYMENT,
  PAYMENT_DETAIL,
  RESET_PASSWORD,
  CREATE_CUSTOMER,
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  PLAY_NINE_CLUBS,
  PARTNER_FACILITY,
  DESTINATION_LIST,
  CATCHING_TEETIME,
  HOME_PAGE_SETTING,
  AUTHENTICATE_USER,
  DESTINATION_DETAIL,
  GET_LISTING_BOOKING,
  CLUB_SORTING_OPTIONS,
  FEATURED_CLUBS_NEAR_ME,
  PAYMENT_UPDATE_BOOKING,
  TODAYS_BEST_DEAL_NEAR_ME,
  TEACHING_PRO_CLUBS_NEAR_ME,
  DRIVING_RANGE_CLUBS_NEAR_ME,
  PUTTING_GREEN_CLUBS_NEAR_ME,
  PITCHING_AREA_CLUBS_NEAR_ME,
} from "@utils/config";
import { GET_USER } from "@utils/config";

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 1000000,
});

instance.interceptors.request.use(
  async function (request) {
    let userDetails = await Storage.get(Storage.USER_TOKEN);
    if (userDetails) {
      let token = localStorage.getItem("C2H_UserToken");
      request.headers.authorization = `Bearer ${token}`;
    }
    return request;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const authenticateUserApi = (data) => {
  return instance.post(AUTHENTICATE_USER, data);
};
export const registerUserApi = (data) => {
  return instance.post(REGISTER_USER, data);
};
export const updateUserApi = (data) => {
  return instance.put(`${UPDATE_USER}/${data?.id}`, data?.data);
};
export const changePasswordApi = (data) => {
  return instance.post(CHANGE_PASSWORD, data);
};
export const getUserApi = (data) => {
  return instance.get(`${GET_USER}/${data}?populate=*`);
};
export const profilePhotoApi = (data) => {
  return instance.post(PROFILE_PHOTO, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const resetPasswordApi = (data) => {
  return instance.post(`${RESET_PASSWORD}`, data, {
    headers: { Authorization: `Bearer ${data?.token}` },
  });
};
export const getLatestReviewApi = () => {
  return instance.get(LATEST_REVIEW);
};
export const reviewRatingApi = (data) => {
  return instance.post(`${REVIEW_RATING}`, data);
};
export const catchingTeetimeApi = (data) => {
  return instance.get(
    `${CATCHING_TEETIME}/${data.id}?bookingDate=${data.bookingDate}&holes=${data.holes}&players=${data.players}`
  );
};
export const menus = (data) => {
  return instance.get(`${MENUS}`, { params: { populate: "*", locale: data } });
};

export const header = (data) => {
  return instance.get(HEADERS, data);
};
export const getClubDetailApi = (data) => {
  return instance.get(`${CLUB_DETAIL}/${data}?populate=*`);
};
export const getClubPolicyApi = (data) => {
  return instance.get(`${CLUB_POLICY}/${data}?populate=*`);
};
export const clubTeeTimeApi = (data) => {
  return instance.get(
    `${CLUB_TEE_TIME}/${data?.clubId}?bookingDate=${data?.bookingDate}&holes=${data?.holes}&players=${data?.players}`
  );
};
export const clubCachedTeeTimeApi = (data) => {
  return instance.get(
    `${CATCHING_TEETIME}/${data?.clubId}?bookingDate=${data?.bookingDate}&holes=${data?.holes}&players=${data?.players}&courseId=${data?.courseId}&isGolfPass=true`
  );
};
export const getHomePageSettingApi = (data) => {
  return instance.get(HOME_PAGE_SETTING, { params: { locale: data } });
};
export const getSettingApi = (data) => {
  return instance.get(SETTING, { params: { locale: data } });
};
export const getPrivacyDataApi = (slug) => {
  return instance.get(`${STATIC_PAGE}/${slug}`);
};
export const getCancellationPolicyApi = (slug) => {
  return instance.get(`${STATIC_PAGE}/${slug}`);
};
export const getAbout_US_Api = (slug) => {
  return instance.get(`${STATIC_PAGE}/${slug}`);
};
export const getTermsApi = (slug) => {
  return instance.get(`${STATIC_PAGE}/${slug}`);
};
export const getStaticPageApi = (slug) => {
  return instance.get(`${ALL_STATIC_PAGE}/${slug}`, {
    params: { populate: "*" },
  });
};
export const forgotPasswordApi = (data) => {
  return instance.post(FORGOT_PASSWORD, data);
};
export const bookingTeetimeApi = (data) => {
  return instance.post(BOOK_TEETIME, data);
};
export const getListingBookingsApi = (data) => {
  return instance.get(
    `${GET_LISTING_BOOKING}?fromDate=${data?.fromDate}&toDate=${data?.toDate}`
  );
};
export const createCustomerApi = (data) => {
  return instance.post(CREATE_CUSTOMER, data);
};
export const createpaymentApi = (data) => {
  return instance.post(CREATE_PAYMENT, data);
};
export const confirmPaymentErrorApi = (data) => {
  return instance.post(CONFIRM_PAYMENT_ERROR, data);
};
export const getPaymentApi = (data) => {
  return instance.post(GET_PAYMENT, data);
};
export const paymentUpdateBookingApi = (data) => {
  return instance.post(PAYMENT_UPDATE_BOOKING, data);
};
export const getFacilitieApi = (data) => {
  return instance.get(`${FACILITES}/${data}`);
};
export const clubSearchApi = (data) => {
  return instance.get(`${CLUB_SEARCH}?search=${data?.toLowerCase()}`);
};
export const queryApi = (data) => {
  return instance.post(QUERY, data);
};

export const newsApi = (data) => {
  return instance.get(`${NEWS}`, { params: { populate: "*", locale: data } });
};
export const newsDetail = (data) => {
  return instance.get(`${NEWS}/${data.id}`, { params: { locale: data.lang } });
};
export const newsLetterApi = (data) => {
  return instance.post(NEWSLETTER, data);
};
export const searchNewsApi = (data) => {
  return instance.get(`${NEWS}/search`, { params: { populate: "*", ...data } });
};
export const likeApi = (id) => {
  return instance.post(`${LIKE}/${id}`);
};
export const addCommentApi = (data) => {
  return instance.post(COMMENT, data);
};
export const addFavClubApi = (id) => {
  return instance.post(`${LIKE_CLUB}/${id}`);
};
export const getFavClubApi = () => {
  return instance.get(`${LIKE_CLUB}`);
};
export const getPartnerFacilityApi = (data) => {
  return instance.get(`${PARTNER_FACILITY}/${data}`);
};
export const getPaymentDetailApi = (data) => {
  return instance.get(`${PAYMENT_DETAIL}/${data}`);
};
export const getOTPApi = (data) => {
  return instance.post(`${USER_OTP}`, data);
};
export const cancelBookingAPI = (data) => {
  return instance.post(`${CANCEL_BOOKING}`, data);
};

export const clubSortingOptionsApi = (data) => {
  return instance.get(CLUB_SORTING_OPTIONS, { params: { locale: data } });
};
export const searchClubsApi = (data) => {
  return instance.get(SEARCH_CLUBS, { params: data });
};

export const getFeaturedClubsNearMeApi = () => {
  return instance.get(FEATURED_CLUBS_NEAR_ME);
};
export const getBannerApi = () => {
  return instance.get(BANNER);
};
export const getTodaysBestClubDealsNearMeApi = (data) => {
  return instance.post(TODAYS_BEST_DEAL_NEAR_ME, data);
};
export const getPlayNineClubsApi = () => {
  return instance.get(PLAY_NINE_CLUBS);
};
export const getDrivingRangeClubsNearMeApi = () => {
  return instance.get(DRIVING_RANGE_CLUBS_NEAR_ME);
};
export const getPuttingGreenClubsNearMeApi = () => {
  return instance.get(PUTTING_GREEN_CLUBS_NEAR_ME);
};
export const getTeachingProClubsNearMeApi = () => {
  return instance.get(TEACHING_PRO_CLUBS_NEAR_ME);
};
export const getPitchingAreaClubsNearMeApi = () => {
  return instance.get(PITCHING_AREA_CLUBS_NEAR_ME);
};
export const exploreGameApi = (data) => {
  return instance.get(EXPOLRE_GAME);
};
export const getCountrysListApi = () => {
  return instance.get(COUNTRY_LIST);
};
export const getDestinationListApi = (data) => {
  // return instance.get(DESTINATION_LIST);
  return instance.get(DESTINATION_LIST, { params: { locale: data } });
};
export const getDestinationDetailApi = (data) => {
  // return instance.get(`${DESTINATION_DETAIL}/${data.value}`);
  return instance.get(`${DESTINATION_DETAIL}/${data.value}`, {
    params: { locale: data.lunguage },
  });
};
